<div class="opacity-slider-container">
  <div class="label-container">
    <i class="material-symbols-outlined">visibility_off</i>
    <span class="label-text">{{T.common.overlay_opacity | translate}}:</span>
    <span class="value-text">{{ value }}%</span>
  </div>
  <div class="opacity-slider-wrapper">
    <ngx-slider
      [value]="value"
      [options]="opacitySliderOptions"
      (valueChange)="onOpacityChange($event)"
    ></ngx-slider>
  </div>
</div>
